module.exports = __webpack_public_path__ + "static/img/email-icon.0f1e4b3a.svg";